import { useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../store";
import CustomButton from "../CustomButton";
import DataTable, { Column } from "../DataTable";
import ModalLayout from "../layouts/ModalLayout";
import { useDispatch } from "react-redux";
import { Student } from "../../types/studentType";
import { useEffect, useState } from "react";
import { getStudents } from "../../features/student/StudentSlice";
import { useBranchCode } from "../../util/hooks/useBranch";

interface Props {
  onClose?: (data?: { selectedStudentIds: number[] }) => void;
}

export default function AddRecipient({ onClose }: Props) {
  const dispatch = useDispatch<AppDispatch>();
  const [selectedIds, setSelectedIds] = useState<number[]>([]);

  const { students, isLoading } = useSelector(
    (state: RootState) => state.student,
  );

  const branchCode = useBranchCode();

  useEffect(() => {
    dispatch(getStudents({ page: 0, size: 10000, branchCode }));
  }, [dispatch, branchCode]);

  const columns: Column<Student>[] = [
    {
      label: <input type="checkbox" className="w-3 h-3" />,
      accessor: "select",
      render: (item) => (
        <input
          type="checkbox"
          checked={selectedIds.includes(item.admissionNumber)}
          onChange={() =>
            setSelectedIds((prev) =>
              prev.includes(item.admissionNumber)
                ? prev.filter((id) => id !== item.admissionNumber)
                : [...prev, item.admissionNumber],
            )
          }
        />
      ),
    },
    { label: "SL NO.", accessor: "admissionNumber" },
    {
      label: "Profile",
      accessor: "fullName",
      render: (item) => (
        <div>
          {!item?.photoUrl ? (
            <div className="flex items-center justify-center w-10 h-10 rounded-full bg-primary-600 text-white font-semibold">
              {item.fullName.charAt(0).toUpperCase()}
            </div>
          ) : (
            <img
              src={item?.photoUrl}
              alt=""
              className="flex items-center justify-center object-cover w-10 h-10 rounded-full"
            />
          )}
        </div>
      ),
    },
    {
      label: "Students Name",
      accessor: "fullName",
      render: (item) => (
        <div className="font-bold text-sm text-neutral-400">
          {item.fullName}
        </div>
      ),
    },
  ];

  return (
    <ModalLayout onClose={onClose} width="max-w-xl">
      <div className="flex flex-col gap-7 md:max-h-96 overflow-y-auto custom-scrollbar">
        <span className="font-semibold text-xl text-neutral-400">
          Select Recipient
        </span>

        <DataTable columns={columns} data={students} isLoading={isLoading} />

        <div className="flex gap-4 justify-end items-end">
          <CustomButton
            text="Cancel"
            color="bg-neutral-200"
            onClick={() => onClose?.()}
          />
          <CustomButton
            text="Confirm"
            color="bg-primary-500"
            onClick={() => {
              onClose?.({ selectedStudentIds: selectedIds });
            }}
          />
        </div>
      </div>
    </ModalLayout>
  );
}
